export const shippingServices = state => state.shippingServices;

export const loadingState = state => state.loading;
